import { Toast } from "vant"
import { getUserInfoFromLocal } from './token'
import  collect  from './collect'
/**
 * 获取当前运行环境，包括：iOS、Android、Chrome 模拟器、微信等
 * @return {}
 */
export const getEnvInfo = () => {
  let system = {
    win: false,
    mac: false,
    x11: false,
    iOS: false,
    android: false,
    wechat: false,
    ali:false
  }
  const p = navigator.platform
  system.win = p.indexOf('Win') === 0
  system.mac = p.indexOf('Mac') === 0 || p.indexOf('mac') === 0
  system.x11 = p === 'X11' || p.indexOf('Linux') === 0
  system.iOS = p.indexOf('iP') === 0
  const ua = navigator.userAgent.toLowerCase()
  system.android = ua.indexOf('android') > -1
  system.wechat = ua.indexOf('micromessenger') !== -1
  system.ali = ua.indexOf('aliapp') !== -1
  return system
}

const getEnvInfoStr = () => {
  let system = getEnvInfo()
  if (system.wechat) {
    return 'WeChat'
  } else if (system.iOS) {
    return 'iOS'
  } else if (system.android && !system.win && !system.mac) {
    return 'Android'
  } else if (system.win || system.mac || system.x11) {
    return 'Simulator'
  } else if(system.ali){
    return 'ali'
  } else {
    return 'Unknown Device'
  }
}

export const envInfo = getEnvInfoStr()

export const appVersionGraterThan = function (androidVersion, iOSVersion) {
  let system = getEnvInfo()
  if (system.iOS || system.android) {
    let ua = navigator.userAgent
    let re = /\/[^ ]*/
    let version = String(ua.match(re)).substring(1)
    // console.log(androidVersion)
    // console.log(iOSVersion)
    if (system.android) {
      let vers = version.split('.')
      let localV = parseInt(vers[0]) * 10000 + parseInt(vers[1]) * 100 + parseInt(vers[2])
      let ches = androidVersion.split('.')
      let checkV = parseInt(ches[0]) * 10000 + parseInt(ches[1]) * 100 + parseInt(ches[2])
      return localV > checkV
    }
    return parseInt(version) > parseInt(iOSVersion)
  }
  return false
}

export let backApp = (data) => {
  var platform = getEnvInfoStr()
  if (data) {
    if (platform === 'iOS') {
      window.webkit.messageHandlers.backPressed.postMessage(data)
    } else if (platform === 'Android') {
      window.AnalyticsClickListener.backPressed(JSON.stringify(data))
    } else {
      Toast('不支持当前运行环境')
    }
    return
  }
  if (platform === 'iOS') {
    window.webkit.messageHandlers.backPressed.postMessage({})
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.backPressed()
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 跟app交互 跳转地址
 */
export let redirectApp = (data) => {
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.switchToView.postMessage(data)
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.postSwitchToView(JSON.stringify(data))
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 获取当前链接中包含的参数
 * @return {}
 */
export const getQuery = () => {
  let url = location.search
  let query = new Object()
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      query[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return query
}

export const fix = (num, n) => {
  return (Array(n).join(0) + num).slice(-n)
}

/**
 * 打开备孕教练 IM 页面，渠道：十月必怀
 */
export const tenMonthPregnant = () => {
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.talkToCoach.postMessage({
      type: 'tenMonthPregnant'
    })
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.coachPregnancy()
  }
}

export const coachPregnancy = (channel) => {
  if (!channel) {
    channel = ''
  }
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.talkToCoach.postMessage({
      type: channel
    })
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.coachPregnancy()
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 打开 mpId 对应小程序的 path 页面
 */
export const openMNP = (mpId, path) => {
  let params = {
    mpId,
    path
  }
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCode.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCode(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

const getCSQRCodeParams = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let mPath = mnpPath || 'pages/csqrcode/main'
  let path = `${mPath}?page_title=${encodeURI(groupName)}&group_name=${encodeURI(groupName)}&img_url=${encodeURI(imgUrl)}`
  if (bgImgUrl) {
    path += `&bg_img_url=${encodeURI(bgImgUrl)}`
  }
  if (bottomImgUrl) {
    path += `&bottom_img_url=${encodeURI(bottomImgUrl)}`
  }
  if (backgroundColor) {
    path += `&background_color=${encodeURI(backgroundColor)}`
  }
  if (endBackgroundColor) {
    path += `&end_background_color=${encodeURI(endBackgroundColor)}`
  }
  if (from) {
    path += `&from=${encodeURI(from)}`
  }
  if (fromDesc) {
    path += `&from_desc=${encodeURI(fromDesc)}`
  }
  if (type) {
    path += `&type=${encodeURI(type)}`
  }
  if (pushId) {
    path += `&push_id=${encodeURI(pushId)}`
  }
  if (groupContent) {
    path += `&page_content=${encodeURI(groupContent)}`
  }
  if (style && style.length > 0) {
    path += `&style=${encodeURI(style)}`
  }
  if (liveDate) {
    path += `&live_date=${encodeURI(liveDate)}`
  }
  return {
    path: path
  }
}

/**
 * 打开小程序“客服”二维码页面，进入“引导加群”等流程
 */
export const openCSQRCode = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let params = getCSQRCodeParams(groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate)
  console.log(decodeURIComponent(params.path))
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCode.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCode(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 打开小程序“客服”二维码页面，进入“引导加群”等流程。需要 App 端限制 “用户已绑定微信”
 */
export const openCSQRCodeWithUnionId = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let token = getUserInfoFromLocal().authToken 
  collect.track(token, type)
  console.log(token, type)
  let params = getCSQRCodeParams(groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate)
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCodeWithUnionId.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCodeWithUnionId(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

export const openPregnantMaster = (param) => {
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    if (window.webkit.messageHandlers.callPregnancyMaster) {
      window.webkit.messageHandlers.callPregnancyMaster.postMessage(param)
      return
    }
  } else if (system === 'Android') {
    if (window.AnalyticsClickListener.callPregnancyMaster) {
      window.AnalyticsClickListener.callPregnancyMaster(JSON.stringify(param))
      return
    }
  }
  Toast('不支持当前运行环境')
}

export const openPregnantIn9CyclesHelper = (groupName, imgUrl, bgImgUrl, pushId) => {
  let backgroundColor = ''
  let endBackgroundColor = ''
  let from = ''
  let fromDesc = ''
  let type = 'pregnant_in_9_cycles'
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    '/paper/pages/csqrcode/main',
    bgImgUrl,
    '',
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type,
    pushId
  )
}

export const openPregnantMaster1v1 = () => {
  // https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png
  // https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/df606536-8c61-44f8-a044-5fe3c6529761_chengguo_contact_qr.jpg
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/da0d9d83-d968-4487-9982-13ca8995057a_pregnant_master_1v1_pic.png'
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#FF5D81'
  let endBackgroundColor = '#FF8960'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = 'test_temp_plan'
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}
export const openPregnantMaster1v1ByType = (source) => {
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/da0d9d83-d968-4487-9982-13ca8995057a_pregnant_master_1v1_pic.png'
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#FF5D81'
  let endBackgroundColor = '#FF8960'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = source
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}
export const openPregnantMaster1v1ByTypeAndImg = (source, bg) => {
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = bg
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#AFD0F9'
  let endBackgroundColor = '#AFD0F9'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = source
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}

export const getImUrl = () => {
  let imUrl
  if (process.env.VUE_APP_MODE === 'production') {
    imUrl = 'https://static.shecarefertility.com/shecare/im/dist/index.html#/Customer'
  } else {
    imUrl = 'https://static.shecarefertility.com/shecare/test/im/dist/index.html#/Customer'
  }
  return imUrl
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}


export const getShopUrl = () => {
  let shopUrl
  if (process.env.VUE_APP_MODE === 'production') {
    shopUrl = 'https://wechat.shecarefertility.com/dist/index.html#/'
  } else {
    shopUrl = 'https://testwechat.shecarefertility.com/dist/index.html#/'
  }
  return shopUrl
}

/**
 * 有赞商品path
 */
export const yzPaths = () => {
  return {
    // ht: 'pages/common/blank-page/index?scene=906136275',//红妥
    ht:'pages/common/blank-page/index?scene=1094495787',//红妥无货备用
    htbl: 'pages/common/blank-page/index?scene=1089389237',//红妥伴侣
    lt: 'pages/common/blank-page/index?scene=1089389707',//绿妥
    tj: 'pages/common/blank-page/index?scene=1089389845',//妥金
    tjbl: 'pages/common/blank-page/index?scene=906138044',//妥金伴侣
    pjb: 'pages/common/blank-page/index?scene=1089390199',//好孕泡脚包
    hcgBox: 'pages/common/blank-page/index?scene=1249783760',//HCG翻倍监测仪下线  换成多联卡
    //hcgMulCard: 'pages/common/blank-page/index?scene=1089394335',//半定量HCG试纸
    hcgMulCard: 'pages/common/blank-page/index?scene=1249783760',//半定量HCG试纸 美丽泰格
    // fh: 'pages/common/blank-page/index?scene=906241277'//胎心仪
    // fh: 'pages/common/blank-page/index?scene=1492696815',//胎心仪
    fh: 'pages/common/blank-page/index?scene=1113503444',
    fhrm: 'pages/common/blank-page/index?scene=1291081498',
    hyn:'packages/goods/detail/index?alias=2786yfo00aa7z1e&shopAutoEnter=1',
    hcg:'pages/common/blank-page/index?scene=1504096997'
  }
}

/**
 * 淘宝商品url
 */
export const taobaoUrls = () => {
  return {
    hcgMulCard: 'https://s.click.taobao.com/t?e=m%3D2%26s%3DAE6SakEzRCxw4vFB6t2Z2ueEDrYVVa64YUrQeSeIhnK53hKxp7mNFupH%2BKVf1Vvf4eJBHZVk4jqFM4z8qDx5Q9TjdqqJkqKEidR2TIpAHmkJKsrtStgAkfZYjJhf%2FvxLDoqEt4dKdN30KBFKq4PCn7yb%2FZ8PTafbX3JxdfshK570aanjoFRk4atWXPV5Utho%2FjoRN7Bx0rcyroRXAb21pcx2uKb%2Fz8YIS2rkjZmxjOfnckQqChjMto%2BDKwFLEd9Q5dUsQ8NYvbj%2B58h5pKGYuym%2Fvt5hDntLZ6p3Ndoi1%2BbGDF1NzTQoPw%3D%3D&union_lens=lensId%3APUB%401747278443%400bbb5448_1127_196d1e932d5_cf8a%40022jY5QN7VcEq30o5Sc5BuZL%40eyJmbG9vcklkIjo4MDY3NCwiic3BtQiiI6Il9wb3J0YWxfdjJfcGFnZXNfcHJvbW9fZ29vZHNfaW5kZXhfaHRtIiiwiic3JjRmxvb3JJZCI6IjgwNjc0In0ie%3BtkScm%3AselectionPlaza_site_4358_0_0_0_1_174727844326497378360%3Bscm%3A1007.30148.329090.pub_search-item_237f62a4-b3f1-4f0f-a94e-86a225e82958_',//半定量HCG试纸 金华科
    fh: 'https://uland.taobao.com/coupon/edetail?e=e9q6buPdWD%2BlhHvvyUNXZfh8CuWt5YH551NtNRhtOmS6joFKYFdMmddcBSj4yoDJWiVdn%2BK6s%2BqMf%2BQeZ1F6pPMfSkLz3sFqFxLH55fEO4nabAJjl9LutWtN1PtyBd%2FqOBhJinGZi0yZbwwA1A03h0YrsVNIvVvr0YXwomuBOjQZlcp4Mrmp%2FwwoBlUH3p%2F%2FCt0p7ez%2F3pHzdvg8qipy%2F4%2BjQCvuy0Ok8H8ie0Moz5G3GXpSbfs48mFdlPGLgmLWsCZcSnEIcrlwfwtsMX7mca1VlDG%2FxbB%2FQzRrQSpg8cH6b08Z0n%2BVpRlQAZr1cimSonv6QcvcARY%3D&traceId=2150b64817472236079287866e39b4&union_lens=lensId%3APUB%401747223517%400b516b8d_12d7_196cea3176f_6076%40025h0G9oZ14b83pnQP8SwZm4%40eyJmbG9vcklkIjo4MDY3NCwiic3BtQiiI6Il9wb3J0YWxfdjJfcGFnZXNfcHJvbW9fZ29vZHNfaW5kZXhfaHRtIiiwiic3JjRmxvb3JJZCI6IjgwNjc0In0ie%3BtkScm%3AselectionPlaza_site_4358_0_0_0_1_174722351706897378360%3Bscm%3A1007.30148.329090.pub_search-item_ae5ecbef-d806-48ec-8eef-4a9011bf39dc_',
    fhrm: 'https://uland.taobao.com/coupon/edetail?e=GmZfrOhtnaClhHvvyUNXZfh8CuWt5YH551NtNRhtOmSb5K%2BPWj4V7mQ4jBHU6SiQh%2FD%2F1kxsY7Zz35oCbY8z07Nh6CdWAgdCbzxk%2FJYCTThFIe9B7aM4tn2ls0JhfQj48%2F5ZROAr%2F7Qj61pSBu51TED7nfpqxiwt6uEs4UftlImTliMjGoFgc85Fjk%2BjRxDciD1E4uA2sacr6KubAAhdcIHaYzklrDpDMWXqUrvOSgAjPB6wO%2BEqyaLPR9YB94xWCYZ46PAwjRJb6KFd96Xrxpr5CldOdWGaGVuX%2FRPhpQWEiTPkzUJn1UmJtV%2Fev3IBJTNWSR3CwiY%3D&traceId=2167264217472768889272479ea342&union_lens=lensId%3APUB%401747276806%4021336275_11b9_196d1d039cd_c86b%400231dt0XkuWfCx9IGCl3pPBF%40eyJmbG9vcklkIjo4MDY3NCwiic3BtQiiI6Il9wb3J0YWxfdjJfcGFnZXNfcHJvbW9fZ29vZHNfaW5kZXhfaHRtIiiwiic3JjRmxvb3JJZCI6IjgwNjc0In0ie%3BtkScm%3AselectionPlaza_site_4358_0_0_0_3_174727680663897378360%3Bscm%3A1007.30148.329090.pub_search-item_a1f6685b-c5ea-43ef-a55b-b9329bff36d1_'
  }
}

export const goBuyUtil = (good) =>{
  if(good === 'hcg'){
    openMNP('gh_6e51874b9360', yzPaths().hcg)
  } else if(good === 'hcgMulCard'){
    redirectBrowser(taobaoUrls().hcgMulCard)
  } else if(good === 'fh' || good === 'txy'){
    redirectBrowser(taobaoUrls().fh)
  } else if(good === 'fhrm'){
    redirectBrowser(taobaoUrls().fhrm)
  }
}
/**
 * 打开浏览器
 */
export let redirectBrowser = (taobaoUrl, taobaoUrlIos) => {
  if (!taobaoUrlIos) {
    taobaoUrlIos = taobaoUrl
  }
  var system = getEnvInfoStr()
  if (system === 'WeChat') {
    window.open(taobaoUrl)
  } else if (system === 'iOS') {
    window.webkit.messageHandlers.openOutsideUrl.postMessage({
      redirectUrl: taobaoUrlIos
    })
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openOutsideUrl(taobaoUrl)
  } else {
    window.open(taobaoUrl)
  }
}
export const openDepositAlipay = (param) => {
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    if (window.webkit.messageHandlers.openDepositAlipay) {
      window.webkit.messageHandlers.openDepositAlipay.postMessage(param)
      return
    }
  } else if (system === 'Android') {
    if (window.AnalyticsClickListener.openDepositAlipay) {
      window.AnalyticsClickListener.openDepositAlipay(JSON.stringify(param))
      return
    }
  }
  Toast('不支持当前运行环境')
}